import { ILandingPage, IPageSection } from '../../types/@types/generated/contentful';
import { captureException } from '../../utils/tracking/sentry/sentry';
import { SECTION_MAP_RENDER } from './pageSections';

type SectionProps = {
  section: IPageSection;
};

type Props = {
  page: ILandingPage;
  section: IPageSection;
  serverSideProps: Record<string, unknown>;
  index?: number;
};

const PageSection = ({ index, page, section, serverSideProps }: Props) => {
  const Component = getComponentFromType({ section });
  if (!Component) {
    return null;
  }
  return (
    <Component page={page} section={section} serverSideProps={serverSideProps} index={index} />
  );
};

const getComponentFromType = ({ section }: SectionProps) => {
  const Component = section.fields.type && SECTION_MAP_RENDER[section.fields.type];
  if (!Component) {
    captureException(new Error(`No component found for section type ${section.fields.type}`));
    return;
  }
  return Component;
};

export default PageSection;
